// Compute the current open/closed status of a store from its regular weekly hours
// (hours_struct) and any special/holiday hours (special_hours). Returns null when
// there is no hours information to base a status on.
export function getStoreStatus(hoursStruct, specialHours) {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const todayStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const hm = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  const idx = (now.getDay() + 6) % 7; // Mon=0 .. Sun=6

  // A special entry covering today overrides the regular schedule.
  const sp = (specialHours || []).find(
    (e) => e && e.date && e.date <= todayStr && (e.date_to || e.date) >= todayStr
  );
  if (sp) {
    if (sp.closed) return { open: false, label: "Chiuso oggi", detail: sp.label || "Chiusura straordinaria" };
    const isOpen = sp.from && sp.to && sp.from <= hm && hm < sp.to;
    return isOpen
      ? { open: true, label: "Aperto ora", detail: sp.label || "" }
      : { open: false, label: "Chiuso ora", detail: sp.label || "" };
  }

  if (!Array.isArray(hoursStruct) || !hoursStruct.length) return null;
  const d = hoursStruct[idx] || {};
  const ranges = (d.ranges || []).filter((r) => r && r.from && r.to);
  if (d.closed || !ranges.length) return { open: false, label: "Chiuso oggi", detail: "" };

  const cur = ranges.find((r) => r.from <= hm && hm < r.to);
  if (cur) return { open: true, label: "Aperto ora", detail: `fino alle ${cur.to}` };

  const next = ranges.map((r) => r.from).filter((f) => f > hm).sort()[0];
  return { open: false, label: "Chiuso ora", detail: next ? `apre alle ${next}` : "" };
}
